import cookies from "js-cookie";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { getBrowser } from '../browser';

export default {
    async reportPoint(eventname, label) {
        try {
            if (window.setSaviorData) {
                const fp = await FingerprintJS.load();
                const { visitorId } = await fp.get();
                setSaviorData({
                    base: {
                        rootpaltid: getRootpaltid(),
                        appversion: getAppVersion()
                    },
                    user: {
                        memberid: cookies.get("userId") || "",
                        ecrd: cookies.get("memberUniqueId") || "",
                        islogin: cookies.get("token") ? 1 : 0,
                        tc_deviceid: cookies.get("deviceId") || visitorId,
                        el_deviceid: cookies.get("deviceId") || visitorId,
                    },
                    page: {
                        eventid: "cloud_web_operation",
                        eventtype: "click",
                        eventname: eventname,
                        action: "click",
                        label: label,
                    }
                });
            }
        } catch (error) {
            console.log('BuriedERROR:', error);
        }
    },

    async reportWSErrorPoint(userId) {
        try {
            if (window.setSaviorData) {
                const fp = await FingerprintJS.load();
                const { visitorId } = await fp.get();
                setSaviorData({
                    base: {
                        rootpaltid: getRootpaltid(),
                        appversion: getAppVersion()
                    },
                    user: {
                        memberid: cookies.get("userId") || "",
                        ecrd: cookies.get("memberUniqueId") || "",
                        islogin: cookies.get("token") ? 1 : 0,
                        tc_deviceid: cookies.get("deviceId") || visitorId,
                        el_deviceid: cookies.get("deviceId") || visitorId,
                    },
                    page: {
                        eventid: "server_crash_window",
                        eventtype: "show",
                        eventname: 'ws_error_close',
                        action: "show",
                        label: 'ws_error_close',
                        value: userId,
                    }
                });
            }
        } catch (error) {
            console.log('BuriedERROR:', error);
        }
    }
}

function getRootpaltid() {
    let isMobile = getBrowser().isMobile;
    let isInToca = getBrowser().isInTocaApp;
    if (isInToca === true) {
        if (isMobile === true) {
            return '2'; //移动端
        } else {
            return '0'; //pc
        }
    } else {
        return '1'; //web
    }
}


function getAppVersion() {
    const ua = window.navigator.userAgent || '';
    const matchs = ua.match(/(toca|tiexin)\/([\d\.]+)/i);
    return matchs ? matchs[2] : '';
}
